import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.fragment.html',
  styleUrls: [
    './alert-message.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class AlertMessageFragment implements OnInit {

  public header = '';
  public msg = '';
  public buttonText: string;
  public errorDetails?: string;
  public showDetails = false;

  @Output() public closeEmitter = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeAlertModal();
  }

  public closeAlertModal(value = undefined): void {
    this.closeEmitter.emit(!!value);
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

}
